import {combineReducers} from 'redux';
import {localeReducer} from 'react-localize-redux';

import stepsReducer from "./stepsReducer";
import wtReducer from './wtReducer';
import dwdfReducer from './dwdfReducer';
import breadcrumbsReducer from './breadcrumbsReducer';
import bathtubReducer from './bathtubReducer';
import loadingReducer from './loadingReducer';
import imageReducer from './imageReducer';
import articleReducer from './articleReducer';
import summaryReducer from './summaryReducer';
import formInputReducer from "./formInputReducer";
import togglePriceReducer from "./togglePriceReducer";
import krwReducer from "./krwReducer";

export default combineReducers({
    locale:      localeReducer,
    steps:       stepsReducer,
    wt:          wtReducer,
    dwdf:        dwdfReducer,
    bathtub:     bathtubReducer,
    krw:         krwReducer,
    breadcrumbs: breadcrumbsReducer,
    image:       imageReducer,
    loading:     loadingReducer,
    articleID:   articleReducer,
    summary: summaryReducer,
    formInput:   formInputReducer,
    showPrices: togglePriceReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js